import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { ReactNode } from 'react';

// Create a client
const queryClient = new QueryClient( {
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 1,
        },
    },
} );

interface QueryProviderProps {
    children: ReactNode;
}

export function QueryProvider( { children }: QueryProviderProps ) {
    return (
        <QueryClientProvider client={queryClient}>
            {children}
        </QueryClientProvider>
    );
}